import React, { FunctionComponent, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { ContentSection, Layout, PageWrap, Paragraph, SectionHeading } from '@vwfs-bronson/bronson-react';
import { Analytics } from '../../services/analytics';
import { creditCheckPageEvent } from '../../services/analytics/analyticsEvents';

export const CreditCheckRejectionPage: FunctionComponent = () => {
  const { t } = useTranslation();

  useEffect(() => {
    Analytics.push(creditCheckPageEvent('rejection'));
  }, []);

  return (
    <>
      <PageWrap>
        {/*
        PC-2996
        <ContentSection pageWrap className="u-border u-mt-xlarge">
          <ShoppingCart formData={formData} dataTheme="default" />
        </ContentSection> */}
        <ContentSection className="u-border">
          <SectionHeading center level={2} className="u-mb-xsmall">
            {t('creditCheckRejection:heading')}
          </SectionHeading>
          <ContentSection pageWrapSize="small">
            <Layout center>
              <div className="u-block-center u-h1">
                <i className="c-icon  c-icon--[semantic-edit] c-icon--xxlarge" />
              </div>
            </Layout>
            <Layout center>
              <Layout.Item default="3/4">
                <Paragraph>{t('creditCheckRejection:text1')}</Paragraph>
                <br />
                <Paragraph>{t('creditCheckRejection:text2')}</Paragraph>
              </Layout.Item>
            </Layout>
          </ContentSection>
        </ContentSection>
        <br />
      </PageWrap>
    </>
  );
};
